module.exports = __webpack_public_path__ + "img/video_fm.093ce1c9.jpg";